import { createBrowserRouter } from "react-router-dom";
import { Suspense, lazy } from "react";

const Login = lazy(() => import("../components/authentication/Login"));
const LayoutAuth = lazy(() => import("../layout/authLayout"));
const Dashboard = lazy(() => import("../pages/dashboard"));
const RootLayout = lazy(() => import("../layout/rootLayout"));
const Student = lazy(() => import("../pages/student"));
const Adult = lazy(() => import("../pages/adult"));
const Doctors = lazy(() => import("../pages/doctor"));
const Test = lazy(() => import("../pages/test"));
const Transaction = lazy(() => import("../pages/transaction"));
const Appointment = lazy(() => import("../pages/appointment"));
const Loader = lazy(() => import("../components/Spinner/Loader"));
const Form = lazy(() => import("../components/form/form"));
const AdminRoute = lazy(() =>
  import("../components/privateRoutes/adminRoutes")
);
const Alerts = lazy(() => import("../pages/alerts"));
const View = lazy(() => import("../components/view/candidate"));
const NotFound = lazy(() => import("../pages/notFound"));
const TestPricing = lazy(() => import("../pages/testPricing"));

const Loading = () => {
  return (
    <div>
      <Loader />
    </div>
  );
};

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<Loading />}>
        <LayoutAuth />
      </Suspense>
    ),
    children: [
      {
        path: "/",
        element: (
          <Suspense fallback={<Loading />}>
            <Login />
          </Suspense>
        ),
      },
    ],
  },

  {
    element: <AdminRoute />,
    children: [
      {
        path: "/",
        element: (
          <Suspense fallback={<Loading />}>
            <RootLayout />
          </Suspense>
        ),
        children: [
          {
            path: "/dashboard",
            element: (
              <Suspense fallback={<Loading />}>
                <Dashboard />
              </Suspense>
            ),
          },
          {
            path: "/students",
            element: (
              <Suspense fallback={<Loading />}>
                <Student />
              </Suspense>
            ),
          },
          {
            path: "/adults",
            element: (
              <Suspense fallback={<Loading />}>
                <Adult />
              </Suspense>
            ),
          },
          {
            path: "/doctors",
            element: (
              <Suspense fallback={<Loading />}>
                <Doctors />
              </Suspense>
            ),
          },
          {
            path: "/test",
            element: (
              <Suspense fallback={<Loading />}>
                <Test />
              </Suspense>
            ),
          },
          {
            path: "/transaction",
            element: (
              <Suspense fallback={<Loading />}>
                <Transaction />
              </Suspense>
            ),
          },
          {
            path: "/appointment",
            element: (
              <Suspense fallback={<Loading />}>
                <Appointment />
              </Suspense>
            ),
          },
          {
            path: "/alerts",
            element: (
              <Suspense fallback={<Loading />}>
                <Alerts />
              </Suspense>
            ),
          },
          {
            path: "/test-pricing",
            element: (
              <Suspense fallback={<Loading />}>
                <TestPricing />
              </Suspense>
            ),
          },
          {
            path: "/form",
            element: (
              <Suspense fallback={<Loading />}>
                <Form />
              </Suspense>
            ),
          },
          {
            path: "/view",
            element: (
              <Suspense fallback={<Loading />}>
                <View />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
  {
    path: "*",
    element: (
      <Suspense fallback={<Loader />}>
        <NotFound />
      </Suspense>
    ),
  },
]);
